import React, { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import {
  bodyShapeArray,
  downplayArray,
  heightArray,
  occasionArray,
  paletteOptions,
  styleIdentityArray,
} from "utils/staticData";
import { Star } from "utils/text";
import Select from "react-select";
import { color } from "@mui/system";
import {
  masterBrandListApi,
  masterClothingCategoriesListApi,
  masterColorApi,
  masterSizeApi,
} from "services/master";
import { toastMessage } from "utils/toastMessage";

const Form = ({ selectedOptions, setSelectedOptions, errors, setErrors, sizeType, setSizeType = () => { } }) => {
  const [categoryList, setCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [colorList, setColorList] = useState([]);
  const [showSize, setShowSize] = useState(false);
  // const [sizeType, setSizeType] = useState("");
  const [sizeList, setSizeList] = useState([]);
  console.log('setSizeType', sizeType)
  //-----------handle-height-------------------
  const handleHeightChange = (selected) => {
    setSelectedOptions((prev) => ({ ...prev, height: selected || [] }));
    setErrors((prevData) => ({ ...prevData, height: null }));
  };
  //-----------handle-Palette-Options-------------------
  const handlePaletteOptions = (selected) => {
    setSelectedOptions((prev) => ({ ...prev, paletteName: selected || [] }));
    setErrors((prevData) => ({ ...prevData, paletteName: null }));
  };
  //-----------handle-Body-Shape-Change-------------------
  const handleBodyShapeChange = (selected) => {
    setSelectedOptions((prev) => ({ ...prev, bodyShape: selected || [] }));
    setErrors((prevData) => ({ ...prevData, bodyShape: null }));
  };
  //-----------handle-StyleIdentity-Change-------------------
  const handleStyleIdentityChange = (selected) => {
    setSelectedOptions((prev) => ({ ...prev, styleIdentity: selected || [] }));
    setErrors((prevData) => ({ ...prevData, styleIdentity: null }));
  };
  //-----------handle-Flaunt-Parts-Change------------------
  const handleFlauntPartsChange = (selected) => {
    setSelectedOptions((prev) => ({ ...prev, flauntParts: selected || [] }));
    setErrors((prevData) => ({ ...prevData, flauntParts: null }));
  };
  //-----------handle-Downplay-Parts-Change------------------
  const handleDownplayPartsChange = (selected) => {
    setSelectedOptions((prev) => ({ ...prev, downplayParts: selected || [] }));
    setErrors((prevData) => ({ ...prevData, downplayParts: null }));
  };
  //-----------handle-Occasion-Name-Change------------------
  const handleOccasionNameChange = (selected) => {
    setSelectedOptions((prev) => ({ ...prev, occasionName: selected || [] }));
    setErrors((prevData) => ({ ...prevData, occasionName: null }));
  };
  //-----------handle-Available-Sizes-Change------------------
  const handleAvailableSizesChange = (selected) => {
    setSelectedOptions((prev) => ({ ...prev, availableSizes: selected || [] }));
    setErrors((prevData) => ({ ...prevData, availableSizes: null }));
  };
  //-------------handle-input-change-------------------
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "category") {
      console.log("name have category", name);
      if (value === "Shoes") {
        setSizeType("shoes");
        setShowSize(false);
      } else if (
        ["Tops", "Bottoms", "Outerwear", "Jumpsuits", "Dresses"].includes(value)
      ) {
        setSizeType("clothes");
        setShowSize(false);
      } else if (["Accessories", "Jewelry"].includes(value)) {
        setShowSize(true);
      }
      sizeListHandler();
    }
    setSelectedOptions((prevData) => ({ ...prevData, [name]: value }));
    setErrors((prevData) => ({ ...prevData, [name]: null }));
  };

  useEffect(() => {
    const categoryListHandler = async () => {
      try {
        const res = await masterClothingCategoriesListApi();

        if (res?.data?.status === 200) {
          setCategoryList(res.data?.data?.categories);
        } else {
          toastMessage(res?.data?.message, "error", "categoryList");
        }
      } catch (e) {
        toastMessage(e.message, "error", "categoryList");
      }
    };
    categoryListHandler();
  }, []);
  //---------------brand-List-Handler-API-------------
  useEffect(() => {
    const brandListHandler = async () => {
      try {
        const res = await masterBrandListApi();
        if (res?.data?.status === 200) {
          setBrandList(res.data?.data?.brands);
        } else {
          toastMessage(res?.data?.message, "error", "brand");
        }
      } catch (e) {
        toastMessage(e.message, "error", "brand");
      }
    };
    brandListHandler();
  }, []);
  //---------------color-List-Handler-API-------------
  useEffect(() => {
    const colorListHandler = async () => {
      try {
        const res = await masterColorApi();
        if (res?.data?.status === 200) {
          setColorList(res.data?.data?.colors);
        } else {
          toastMessage(res?.data?.message, "error", "categoryList");
        }
      } catch (e) {
        toastMessage(e.message, "error", "categoryList");
      }
    };
    colorListHandler();
  }, []);
  //---------------size-List-Handler-API-------------
  const sizeListHandler = async (type = sizeType) => {
    try {
      const res = await masterSizeApi({ type });

      if (res?.data?.status === 200) {
        const sizeOptions = res.data?.data?.sizes.map((size) => ({
          value: size?.name,
          label: size?.name,
        }));
        setSizeList(sizeOptions || []);
      } else {
        toastMessage(res?.data?.message, "error", "categoryList");
      }
    } catch (e) {
      toastMessage(e.message, "error", "categoryList");
    }
  };
  useEffect(() => {
    sizeListHandler();
  }, [sizeType]);
  return (
    <div className="add_model">
      <div className="form_field_wrap">
        <div className="form_field">
          <label className="label">
            Height
            <Star />
          </label>
          <MultiSelect
            className="w-100"
            options={heightArray}
            value={selectedOptions?.height}
            onChange={handleHeightChange}
            overrideStrings={{
              selectSomeItems: "Select height",
            }}
          />
          {errors && <div className="text-danger">{errors.height}</div>}
        </div>
        <div className="form_field">
          <label className="label">
            Palette Name
            <Star />
          </label>
          <MultiSelect
            className="w-100"
            options={paletteOptions}
            value={selectedOptions?.paletteName}
            onChange={handlePaletteOptions}
            overrideStrings={{
              selectSomeItems: "Select palette name",
            }}
          />
          {errors && <div className="text-danger">{errors.paletteName}</div>}
        </div>
      </div>

      <div className="form_field_wrap">
        <div className="form_field">
          <label className="label">Body Shape</label>
          <MultiSelect
            className="w-100"
            options={bodyShapeArray}
            value={selectedOptions?.bodyShape}
            onChange={handleBodyShapeChange}
            overrideStrings={{
              selectSomeItems: "Select body shape",
            }}
          />
        </div>

        <div className="form_field">
          <label className="label">Style Identity</label>
          <MultiSelect
            className="w-100"
            options={styleIdentityArray}
            value={selectedOptions?.styleIdentity}
            onChange={handleStyleIdentityChange}
            overrideStrings={{
              selectSomeItems: "Select style identity",
            }}
          />
          {errors && <div className="text-danger">{errors.styleIdentity}</div>}
        </div>
      </div>
      <div className="form_field_wrap">
        <div className="form_field">
          <label className="label">
            Flaunt Parts
            <Star />
          </label>
          <MultiSelect
            className="w-100"
            options={downplayArray}
            value={selectedOptions?.flauntParts}
            onChange={handleFlauntPartsChange}
            overrideStrings={{
              selectSomeItems: "Select flaunt parts",
            }}
          />
          {errors && <div className="text-danger">{errors.flauntParts}</div>}
        </div>

        <div className="form_field">
          <label className="label">
            Downplay Parts
            <Star />
          </label>
          <MultiSelect
            className="w-100"
            options={downplayArray}
            value={selectedOptions?.downplayParts}
            onChange={handleDownplayPartsChange}
            overrideStrings={{
              selectSomeItems: "Select downplay parts",
            }}
          />
          {errors && <div className="text-danger">{errors.downplayParts}</div>}
        </div>
      </div>
      <div className="form_field_wrap">
        <div className="form_field">
          <label className="label">
            Occasion Name
            <Star />
          </label>
          {/* <Select
                        className="multi-select"
                        isMulti
                        options={occasionArray}
                    // value={occasionArray.filter((occasion) =>
                    //     occasionName.includes(occasion.value)
                    // )}
                    // onChange={handleOccasionChange}
                    /> */}
          <MultiSelect
            className="w-100"
            options={occasionArray}
            value={selectedOptions?.occasionName}
            onChange={handleOccasionNameChange}
            overrideStrings={{
              selectSomeItems: "Select occasion name",
            }}
          />
          {errors && <div className="text-danger">{errors.occasionName}</div>}
        </div>
        <div className="form_field">
          <label className="label">
            Category
            <Star />
          </label>
          <select
            className="input form-control"
            type="text"
            value={selectedOptions?.category || ""}
            name="category"
            onChange={handleInputChange}
          >
            <option value={""}>Select Category</option>
            {categoryList.map((data) => (
              <option key={data._id} value={data.name}>
                {data.name}
              </option>
            ))}
          </select>
          {errors && <div className="text-danger">{errors.category}</div>}
        </div>
      </div>
      <div className="form_field_wrap">
        <div className="form_field">
          <label className="label">
            Brand
            {/* <Star /> */}
          </label>
          <select
            className="input form-control"
            type="text"
            value={selectedOptions?.brand || ""}
            name="brand"
            // error={errors?.brand}
            onChange={handleInputChange}
          >
            <option value=''>Select Brand</option>
            {brandList.map((data) => (
              <option key={data._id} value={data._id}>
                {data.name}
              </option>
            ))}
          </select>
          {errors && <div className="text-danger">{errors.brand}</div>}
        </div>
        <div className="form_field">
          <label className="label">
            Color Name
            <Star />
          </label>

          <select
            className="input form-control"
            value={
              selectedOptions.colorName
                ? JSON.stringify(selectedOptions.colorName)
                : ""
            }
            onChange={(e) => {
              const selectedValue = e.target.value;
              if (selectedValue) {
                try {
                  const parsedValue = JSON.parse(selectedValue);
                  setSelectedOptions((prev) => ({
                    ...prev,
                    colorName: parsedValue,
                  }));
                  setErrors({ ...errors, colorName: null });
                } catch (error) {
                  console.error("Error parsing color value:", error);
                }
              } else {
                setSelectedOptions((prev) => ({ ...prev, colorName: null }));
              }
            }}
          >
            <option value={""}>Select Color</option>
            {colorList.map((data) => (
              <option
                key={data._id}
                value={JSON.stringify({
                  name: data.name,
                  hexCode: data.hexCode,
                })} // Stringify the object
              >
                {data.name}
              </option>
            ))}
          </select>

          {errors && <div className="text-danger">{errors.colorName}</div>}
        </div>
      </div>
      <div className="form_field">
        <label className="label">Available Sizes</label>

        <MultiSelect
          className="w-100"
          options={sizeList}
          value={selectedOptions?.availableSizes}
          onChange={handleAvailableSizesChange}
          overrideStrings={{
            selectSomeItems: "Select available sizes",
          }}
        />
      </div>
    </div>
  );
};

export default Form;
